// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import myAccountFilterSectionStyles from "@steiner/App/SharedStyles/MyAccountPages/List/MyAccountFilterSectionStyles";
import { filterStyles } from "@steiner/App/Widgets/CustomerPartNumbers/CustomerPartNumbersFilter";
import { xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

filterStyles.container = {
    ...myAccountFilterSectionStyles.filterContainer,
};

filterStyles.customerPartNumberGridItem = {
    width: 12,
};

filterStyles.customerPartNumberTextField = {
    cssOverrides: {
        formField: css`
            max-width: 320px;
            ${xScreen("lte", "sm")} {
                max-width: 100%;
            }
        `,
    },
};

filterStyles.clearButtonGridItem = {
    ...myAccountFilterSectionStyles.clearButtonGridItem,
};

filterStyles.clearFiltersButton = {
    ...myAccountFilterSectionStyles.clearButton,
};

filterStyles.appliedFiltersContainer = {
    ...myAccountFilterSectionStyles.appliedFiltersContainer,
};

filterStyles.appliedFilterTag = {
    ...myAccountFilterSectionStyles.appliedFilterTag,
};
